import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ title }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    const titles = {
      "/": "Your Trusted Store for Smartphones & Best Prices - Datacom",
    };

    const pathSegments = pathname.split("/");
    const mainPath = pathSegments[1];
    const subPath = pathSegments[2];

    let dynamicTitle;

    if (mainPath === "cart")
      dynamicTitle = "Your Cart, Your Deals! Complete Your Order - Datacom";
    else if (mainPath === "shipping")
      dynamicTitle = "Shipping Details: Get Your Order Fast - Datacom";
    else if (mainPath === "order")
      dynamicTitle = "Order Details - Track & Manage Your Purchase - Datacom";
    else if (mainPath === "placeorder")
      dynamicTitle = "Order Summary & Checkout - Datacom";
    else if (mainPath === "orderhistory")
      dynamicTitle = "Your Orders - Track & Manage Purchases - Datacom";
    // Handle admin-specific subpages
    else if (mainPath === "admin") {
      if (subPath === "userlist")
        dynamicTitle = "User Management - Admin Dashboard - Datacom";
      else if (subPath === "productlist")
        dynamicTitle =
          "Manage Products - Showcase & Organize Your Catalog - Datacom";
      else if (subPath === "orderlist")
        dynamicTitle = "Order Management - Admin Dashboard - Datacom";
      else if (subPath === "create-product")
        dynamicTitle = "Create New Product - Add to Catalog - Datacom";
      else if (subPath === "product")
        dynamicTitle = "Edit Product - Update & Manage Listings - Datacom";
      else dynamicTitle = "Admin Panel - Manage Datacom Store";
    } else {
      dynamicTitle = titles[pathname] || "Datacom";
    }

    document.title = dynamicTitle;
  }, [pathname]);

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return null;
};

export default ScrollToTop;
